<div [formGroup]="mercadoriaForm">
  <div class="canvas">
    <div class="forms">
      <div class="form-group">
        <label for="tipoMercadoria">Mercadoria</label>
        <select
          class="form-control"
          required
          appShowErrorMessages
          requiredMessage="O campo Mercadoria é obrigatório"
          name="tiposMercadoria"
          formControlName="tiposMercadoria"
        >
          <option value="" hidden selected>Selecione</option>
          <option
            *ngFor="let tipoMercadoria of tiposMercadoria"
            value="{{ tipoMercadoria.id }}"
          >
            {{ tipoMercadoria.descricao }}
          </option>
        </select>
      </div>

      <div class="form-group pb-0">
        <div>
          <label for="valorProduto">Valor do Produto</label>
          <input
            class="form-control"
            required
            type="text"
            placeholder="R$ 00.000,00"
            appOnlyDigitsLengthValidator
            appShowErrorMessages
            requiredMessage="O campo Valor do Produto é obrigatório"
            formControlName="valorProduto"
            name="valorProduto"
            mask-money
            prefix="R$"
            appMoedaValidator
            valorMinimoMessage="Valor mínimo permitido R$"
            valorMinimo="200"
            [maxLength]="15"
          />
        </div>
      </div>
    </div>

    <div>
      <button class="delete-button" (click)="selfDestruct()">
        <em class="fa fa-trash"></em>
      </button>
    </div>
  </div>
</div>
